module.exports = __webpack_public_path__ + "img/noNews.59a7e17c.png";